import { GGSCountryController } from "@goodgamestudios/core";

const LANG_WITH_CUSTOM_FONTS: string[] = [
    "ja",
    "ko",
    "ru",
    "zh_CN",
    "zh_TW"
];

export const fontConfigResolver = () => {
    let lang: string = GGSCountryController.instance.currentCountry.ggsLanguageCode;

    if (!LANG_WITH_CUSTOM_FONTS.includes(lang)) {
        lang = "en";
    }

    // for some languages like chinese there are different language files but fonts are shared. use only main langCode / strip away regional codes
    if (lang.includes("_")) {
        lang = lang.split("_")[0];
    }

    return {
        urls: [`./css/${lang}.css`],
        families: ["_BodyFont", "_HeaderFont"]
    };
};
